import IManufacturer from 'models/Manufacturer';

import { ReduxStore } from 'store/types';

function getAllList(state: ReduxStore): IManufacturer[] {
  return state.manufacturer.getAll.list;
}

export default getAllList;
